export default __webpack_public_path__ + "ui/assets/img/arrow-sort-default-20.svg";